/** @typedef {import('@/features/documentPreview/documentPreviewTypes.js').DocSectionGroup} DocSectionGroup */

export const SYNTHETIC_DATA_DEMO_ARTIFACT_ID = 'synthetic-data-large-ai-models-pdf'

export const SYNTHETIC_DATA_DEMO_PDF_SHORT = 'An_over...licati.pdf'

/** @type {DocSectionGroup[]} */
export const SYNTHETIC_DATA_DEMO_ARTIFACT_SECTIONS = [
  {
    id: 'data-collection',
    page: 11,
    heading: '4.1 Data collection for training',
    level: 2,
    paragraphs: [
      'Publicly available datasets used for training large AI models mainly include resources such as the BookCorpus for books, CommonCrawl for web crawling, Twitter for social media, and GitHub for large-scale public code repositories.',
      'Most of the publicly available resources mentioned above consist of general data with only a small amount of specialized data. Due to limited training data in specialized fields, large AI models often struggle to meet the needs of specific professional domains. To equip general large AI models with the same capabilities as vertical domain large AI models, the collection and organization of training data are crucial.',
    ],
  },
  {
    id: 'virtual-simulation',
    page: 12,
    heading: 'Virtual simulation environments',
    level: 3,
    paragraphs: [
      'Simulating real-world scenarios using virtual engines to provide sufficient data for training and testing large AI models.',
      'Training and testing in virtual environments can significantly reduce the risks and costs of real-world deployment, while enabling faster iteration and optimization of models.',
    ],
  },
  {
    id: 'generative-synthesis',
    page: 12,
    heading: 'Generative model synthesis',
    level: 3,
    paragraphs: [
      'Utilizing excellent generative models to synthesize a large number of images, texts, and other data is an effective method that can provide more training data for various machine learning tasks.',
      'Recently, the University of Hong Kong and ByteDance used the text-to-image generation model (GLIDE) to generate a large number of synthetic images and applied these synthetic data to promote image recognition tasks and pre-training of large AI models.',
    ],
  },
  {
    id: 'domain-gap',
    page: 11,
    heading: 'Domain-specific data gap',
    level: 3,
    paragraphs: [
      'The core motivation is clear: publicly available human-generated data is mostly general-purpose, with very little domain-specific coverage. Synthetic data is proposed precisely to fill this gap.',
    ],
  },
  {
    id: 'model-training',
    page: 12,
    heading: '4.2 Large AI model training',
    level: 2,
    paragraphs: [
      'The enormous number of parameters has significantly increased the training time of large AI models, leading to a significant increase in computational costs. The cost of training GPT-3 is estimated to be approximately $1.4 million per session. For larger LLM models, the training cost ranges from $2 million to $12 million.',
      'Researchers will need to explore how to deeply integrate various parallel acceleration strategies and intelligently adapt training strategies based on the characteristics and training requirements of the model.',
    ],
  },
  {
    id: 'self-supervised-learning',
    page: 16,
    heading: 'Self-supervised and weakly supervised learning',
    level: 3,
    paragraphs: [
      'Self-supervised learning and weakly supervised learning are important directions for the future development of large AI models.',
      'Self-supervised learning allows models to learn the inherent structure and patterns in the data by designing appropriate self-supervised tasks, reducing dependency on costly, curated human labels — a direction where synthetic data naturally excels.',
    ],
  },
  {
    id: 'future-trends',
    page: 16,
    heading: '5.3 Trends in large AI model development',
    level: 2,
    paragraphs: [
      'Since 2018, the parameter indicators of large-scale pre-trained models have been continuously refreshed, with breakthroughs achieved at trillion-parameter scale.',
      'Looking ahead, the industry will be actively exploring ways to put large AI models into practice — including multi-modal fusion, continuous learning, and more efficient training paradigms.',
    ],
  },
]
